import React, { useContext, useEffect, useState } from 'react'
import DateConverter from '../Tools/DateConverter';
import MsgUtils from '../Tools/MsgUtils';
import Modal from 'react-bootstrap/Modal';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function RequerimientosPrincipal() {
    const { loading, setLoading } = useContext(ContextGloball);
    const [fecha, setFecha] = useState(DateConverter.toIsoString(new Date()).substring(0, 10));
    const [sucursales, setSucursales] = useState([]);
    const [idSucursal, setIdSucursal] = useState(-1);
    const [listaRequ, setListaRequ] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectItem, setSelectItem] = useState({});
    const [showModalDeta, setShowModalDeta] = useState(false);
    const [historialSelect, setHistorialSelect] = useState([]);
    function getNombreSuc(id) {
        //console.log('getNombreSuc: ' + id);
        var suc = sucursales.filter(item => item.ID_SUCURSAL == id)
        if (suc.length !== 0) {
            return suc[0].SUCURSAL
        } else {
            return ''
        }
    }
    function obtenerColorS(id) {
        if (id == -800) {
            return ''
        } else if (id == -804) {
            return '#D8D8D8'
        } else if (id == -801) {
            return '#F6CED8'
        } else if (id == -806) {
            return '#E2A9F3'
        } else if (id == -802) {
            return '#F3E2A9'
        } else if (id == -805) {
            return '#A9E2F3'
        }
    }
    function getDetalle(detalle) {
        if (detalle !== null) {
            if (detalle.indexOf('$') != -1) {
                return detalle.substring(detalle.indexOf('$') + 1, detalle.length)
            } else {
                return detalle
            }
        }
    }
    function getUltimoEnvio(historial) {
        if (historial.length !== 0) {
            return (<div>{DateConverter.formatoFechaNumeric(historial[0].FECHA_EMISION)}<span className='text-light' style={{ fontSize: '10px' }}> Cant. </span>{historial[0].CANTIDAD_ORIG}</div>)
        } else {
            return '----'
        }
    }
    function obtenerBoton(dato) {
        //console.log(dato);
        if (dato.ESTADO === 'S') {
            return (<button className='btn btn-sm btn-success' onClick={() => { setSelectItem(dato); setShowModal(true) }}>AUTORIZADO</button>)
        } else if (dato.ESTADO === 'K') {
            return (<button className='btn btn-sm btn-secondary bg-gradient' onClick={() => { setSelectItem(dato); setShowModal(true) }}>BORRADOR</button>)
        } else if (dato.ESTADO === 'N') {
            return (<button className='btn btn-sm btn-warning bg-gradient' onClick={() => { setSelectItem(dato); setShowModal(true) }}>REMITIDO</button>)
        } else if (dato.ESTADO === 'C') {
            if (dato.ESTADO_EGRESO == 'V') {
                return (<button className='btn btn-sm btn-primary bg-gradient' onClick={() => { setSelectItem(dato); setShowModal(true) }}>COMPLETO</button>)
            } else {
                return (<button className='btn btn-sm btn-primary bg-gradient' onClick={() => { setSelectItem(dato); setShowModal(true) }}>PREPARANDO</button>)
            }
        } else if (dato.ESTADO === 'I') {
            return (<button className='btn btn-sm fondoVioleta bg-gradient' onClick={() => { setSelectItem(dato); setShowModal(true) }}>EN REVISION</button>)
        } else if (dato.ESTADO === 'P') {
            return (<button className='btn btn-sm fondoVioleta bg-gradient' onClick={() => { setSelectItem(dato); setShowModal(true) }}>ENVIO PARCIAL</button>)
        } else if (dato.ESTADO === 'R') {
            return (<button className='btn btn-sm btn-danger bg-gradient' onClick={() => { setSelectItem(dato); setShowModal(true) }}>RECHAZADO</button>)
        }
    }
    function obtenerInformacion(fechaB, idSuc) {
        setLoading(true);
        var info = JSON.parse(localStorage.getItem('info'))
        fetch(`${server}/supervision/getRequerimiento`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(
                { 'regional': info.ID_REGIONAL_ACTUAL, 'idSucursal': idSuc, 'fecha': fechaB }
            )
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setListaRequ(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
                setLoading(false)
            })
            .catch(err => console.log(err));
    }
    function obtenerSucurales() {
        var info = JSON.parse(localStorage.getItem('info'))
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(
                { 'regional': info.ID_REGIONAL_ACTUAL }
            )
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setSucursales(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }
    function validarRequerimiento(estado, nombreEstado, selectItem) {
        var info = JSON.parse(localStorage.getItem('info'));
        var tipoAl = [...new Set(selectItem.DETALLE.map((item) => item.ID_ALMACEN_DIRIGIDO))];
        var hayNulos = tipoAl.filter(item => item == null);
        if (hayNulos.length == 0) {
            fetch(`${server}/supervision/accionRequerimiento`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(
                    {
                        'regional': info.ID_REGIONAL_ACTUAL,
                        idSucursal,
                        'sucursal': getNombreSuc(idSucursal),
                        'idEmpleado': info.ID_EMPLEADO,
                        selectItem,
                        'ESTADO': estado,
                        'NOMBRE_ESTADO': nombreEstado,
                        "ID_ALMACEN_DIRIGIDO": tipoAl
                    }
                )
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        MsgUtils.msgCorrecto(data.ok);
                        setShowModal(false);
                        obtenerInformacion(fecha, idSucursal);
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                })
                .catch(err => console.log(err));
        } else {
            MsgUtils.msgError("En este requerimiento se tiene productos con id_dirigido nulo...")
        }
    }
    useEffect(() => {
        obtenerSucurales()
    }, [])
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient'>
                <div className='btn-group'>
                    <div>
                        <input type='date' className='form-control form-control-sm'
                            style={{ minWidth: '110px', maxWidth: '110px' }}
                            value={fecha} onChange={(e) => { setFecha(e.target.value); obtenerInformacion(e.target.value, idSucursal) }}></input>
                        <div className='text-light w-100 text-center' style={{ fontSize: '11px' }}>FECHA</div>
                    </div>
                    <div className='px-1'>
                        <select className="form-select form-select-sm text-start" value={idSucursal}
                            onChange={(e) => { setIdSucursal(e.target.value); obtenerInformacion(fecha, e.target.value) }}>
                            <option value={-1}>Ninguno</option>
                            {sucursales.map((item, index) => {
                                return <option value={item.ID_SUCURSAL} key={index}>{item.SUCURSAL}</option>
                            })}
                        </select>
                        <div className='text-light w-100 text-center' style={{ fontSize: '11px' }}>SUCURSAL</div>
                    </div>
                    <div>
                        <button className='btn btn-success btn-sm w-100' onClick={() => obtenerInformacion(fecha, idSucursal)}><i className="fa-solid fa-rotate-right"></i></button>
                        <div className='text-light w-100 text-center' style={{ fontSize: '11px' }}>RECARGAR</div>
                    </div>
                </div>
            </div>
            <div className='container-fluid py-2'>
                {listaRequ.map((item, index) => {
                    return (
                        <div className='card mb-1' key={index}>
                            <div className='card-header ' style={{ background: obtenerColorS(item.ID_TIPO_REQUERIMIENTO) }}>
                                <div className='row row-cols-2 g-1'>
                                    <div className='text-start col col-9 my-auto'>{item.CATEGORIA}</div>
                                    <div className='text-end col col-3'>{item.ESTADO == 'K' && <button className='btn btn-sm text-danger' onClick={() => validarRequerimiento('E', 'ELIMINADO', item)}><i className="fa-solid fa-trash-can fa-2xl"></i></button>}</div>
                                </div>
                            </div>
                            <div className='card-body'>
                                <div className='row row-cols-2 g-1'>
                                    <div className='col my-auto text-center' style={{ minWidth: '110px', maxWidth: '110px' }}>
                                        <div className='bg-dark text-light fw-bold text-center mb-2' style={{ borderRadius: '10px' }}>{item.ID_REQUERIMIENTO}</div>
                                        {obtenerBoton(item)}
                                    </div>
                                    <div className='col'>
                                        <div style={{ fontSize: '12px' }}> <span>Solicitado por: </span>{item.NOMBREX}</div>
                                        <div style={{ fontSize: '12px' }}> <span>Programado para fecha: </span>{DateConverter.formatoFechaNumeric(item.FECHA)}</div>
                                        <div style={{ fontSize: '12px' }}> <span>Hora de creación de requerimiento: </span>{DateConverter.retornarSoloHoraBoliviana(item.FECHA_SOLICITUD)}</div>
                                        <div style={{ fontSize: '12px' }}> <span>Observacion: </span>{getDetalle(item.OBSERVACIONES)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark'
                centered
            >
                <Modal.Header closeButton closeVariant='white'>
                    <div className='container-fluid'>
                        <div className='row row-cols-2 g-1'>
                            <div className='col col-4'>
                                <div className='text-center text-light' style={{ fontSize: '10px' }}>Nro. Requerimiento</div>
                                <div className='text-center text-light fw-bold'>{selectItem.ID_REQUERIMIENTO}</div>
                            </div>
                            <div className='col col-8'>
                                <div className='text-end text-light'>
                                    {selectItem.CATEGORIA}
                                </div>
                                <div className='text-end text-light'>
                                    {getNombreSuc(idSucursal)}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    <div className='container-fluid table-responsive'>
                        {selectItem.DETALLE !== undefined && <table className="table table-dark table-striped table-sm">
                            <tbody>
                                {selectItem.DETALLE.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <th>
                                                <div className='text-center text-decoration-underline' style={{ fontSize: '11px' }}>
                                                    {item.SIMBOLO}
                                                </div>
                                                <div className='text-center' style={{ fontSize: '23px' }}>
                                                    {item.CANTIDAD}
                                                </div>
                                            </th>
                                            <td>{item.DESCRIPCION}</td>
                                            <td>
                                                <div className='text-center text-decoration-underline' style={{ fontSize: '11px' }}>
                                                    Ultimo Envio
                                                </div>
                                                <div className='text-center'>
                                                    {getUltimoEnvio(item.HISTORIAL)}
                                                </div>
                                            </td>
                                            <td className='my-auto'>
                                                <button className='btn btn-sm btn-secondary' onClick={() => { setHistorialSelect(item.HISTORIAL); setShowModalDeta(true) }}>
                                                    <i className="fa-solid fa-bars fa-2xl">
                                                    </i></button></td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {selectItem.ESTADO !== undefined && selectItem.ESTADO == 'K' &&
                        <button className='btn btn-sm btn-warning' onClick={() => validarRequerimiento('N', 'REMITIDO', selectItem)}>Remitir Req.</button>}
                    {/* {selectItem.ESTADO !== undefined && selectItem.ESTADO == 'N' &&
                        <button className='btn btn-sm btn-success' onClick={() => validarRequerimiento('S', 'AUTORIZADO', selectItem)}>Autorizar Req.</button>} */}
                </Modal.Footer>
            </Modal>
            <Modal
                show={showModalDeta}
                onHide={() => setShowModalDeta(false)}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-secondary'
                centered
            >
                <Modal.Header closeButton closeVariant='white'>
                    <div className='text-light fw-bold text-center w-100'>Hoja historico</div>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    {historialSelect.length !== 0 &&
                        <>
                            <div className='container-fluid'>
                                <div className='text-center fw-bold text-light'>{historialSelect[0].DESCRIPCION}</div>
                            </div>
                            <div className='table-responsive'>
                                <table className="table table-dark table-striped">
                                    <thead className='text-center'>
                                        <tr>
                                            <th >Fecha</th>
                                            <th >Cantidad</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-center'>
                                        {historialSelect.map((item, index) => {
                                            return (
                                                <tr>
                                                    <th>{DateConverter.formatoFechaNumeric(item.FECHA_EMISION)}</th>
                                                    <td>{item.CANTIDAD_ORIG}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </>}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default RequerimientosPrincipal